import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.5994 10.3994L10.3994 21.5994M21.5994 21.5994L10.3994 10.3994L21.5994 21.5994Z", stroke: "#BDBDBD", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
